import React from 'react'
import AsyncSelect from 'src/components/Forms/AsyncSelect'

export default function CompanySelect(props) {
    return (
        <AsyncSelect
            apiConfig={{
                url: '/api/auth/companies',
                params: inputValue => ({
                    page: 1,
                    name_like: inputValue,
                }),
            }}
            itemRenderer={response => {
                return response.data.results.map(item => ({
                    id: item.id,
                    value: item.id,
                    label: item.name,
                }))
            }}
            {...props}
        />
    )
}
